import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{outlet}}\n",{ moduleName: "bullitttime-event/templates/index.hbs" })